export const SelectStyle = {
  width: {
    sm: "w-[150px]",
    md: "w-[300px]",
    lg: "w-[400px]",
  }
}